export default __webpack_public_path__ + "assets/card-logo-hipercard-component.56f0f966.svg";